module.exports = ( $parse ) ->
  return {
    restrict: 'A'

    scope:
      selected:        "=scopeSelectorSelected"
      disableFocused:  "=?scopeSelectorDisableFocused"
      disableEnhanced: "=?scopeSelectorDisableEnhanced"
      disableGlobal:   "=?scopeSelectorDisableGlobal"
      onScopeChange:   "&?scopeSelectorOnChange"

    template: require( './scopeSelector.html' )

    controller: ( $scope, $element, $attrs ) ->
      $scope.onChange = ( scope ) ->
        $scope.onScopeChange( { scope: scope } )
  }
